export const FundingSettingConstants = {
  rewardAmount: "RewardAmount",
  HelpLink:"HelpLink"
};
